<template lang="pug">
  v-card(width=450 style="paddingTop: 40px;borderRadius: 6px;" elevation=4)
    v-card-title(class="mb-3")
      v-layout(row justify-center)
        v-flex(xs12)
          h5(class="headline text-xs-center font-weight-bold") {{$t('StartPage.registerBlock.loginSystem')}}
          p(class="subheader text-xs-center mb-0 grey--text text--darken-2") {{$t('StartPage.registerBlock.enterPin')}}
    v-card-text
      v-layout(row justify-center)
        v-flex(xs10)
          v-form(ref="form", @submit.prevent="sigIn")
            div.field-group
              v-text-field(
                :maxlength="1",
                mask="#",
                name="digit_1",
                ref="digit_1",
                type="password",
                v-model="pin.digit_1",
                autocomplete="off",
                required)
              v-text-field(
                :maxlength="1",
                mask="#",
                name="digit_2",
                ref="digit_2",
                type="password",
                v-model="pin.digit_2",
                autocomplete="off",
                required)
              v-text-field(
                :maxlength="1",
                mask="#",
                name="digit_3",
                ref="digit_3",
                type="password",
                v-model="pin.digit_3",
                autocomplete="off",
                required)
              v-text-field(
                :maxlength="1",
                mask="#",
                name="digit_4",
                ref="digit_4",
                type="password",
                v-model="pin.digit_4",
                autocomplete="off",
                required)
            p(class="text-xs-center red--text", id="errorText") {{ errorText }}
            v-layout(justify-center text-xs-center).mb-4
              v-btn(
                @click.prevent="cancel",
                outline,
                color="blue-grey",
                style="marginRight: 40px",
                large)
                v-icon keyboard_arrow_left
                span.pr-2 {{$t('StartPage.registerBlock.btnCancel')}}
              v-btn(
                color="primary",
                ref="sigIn",
                type="submit",
                :loading="loading",
                :disabled="isDisableBtn",
                @click.prevent="sigIn",
                large)
                span.pl-2 {{$t('StartPage.registerBlock.btnLogin')}}
                v-icon keyboard_arrow_right
</template>

<script>
export default {
  name: 'Pin',
  data: () => ({
    pin: {
      digit_1: '',
      digit_2: '',
      digit_3: '',
      digit_4: ''
    },
    isDisableBtn: true,
    errorText: ''
  }),
  mounted() {
    this.$refs.digit_1.$refs.input.focus()
  },
  watch: {
    'pin.digit_1'(val) {
      if (val) this.$refs.digit_2.focus()
      this.errorText = ''
    },
    'pin.digit_2'(val) {
      if (val) this.$refs.digit_3.focus()
      else this.$refs.digit_1.focus()
      this.errorText = ''
    },
    'pin.digit_3'(val) {
      if (val) this.$refs.digit_4.focus()
      else this.$refs.digit_2.focus()
      this.errorText = ''
    },
    'pin.digit_4'(val) {
      if (!val) this.$refs.digit_3.focus()
      this.errorText = ''
    },
    pinFull(val) {
      this.isDisableBtn = val.length !== 4
    }
  },
  computed: {
    pinFull() {
      return this.pin.digit_1 + this.pin.digit_2 + this.pin.digit_3 + this.pin.digit_4
    },
    loading() {
      return this.$store.state.auth.loading.verifyPin
    }
  },
  methods: {
    cancel() {
      this.$store.dispatch('CANCEL_AUTH')
      this.$emit('next-step', '')
    },
    sigIn() {
      this.$store.dispatch('LOGIN', this.pinFull).then(() => {
        let state = this.$store.state.auth
        if (state.errors.pin) this.errorText = state.errors.pin
        else this.errorText = ''
      })
    }
  }
}
</script>

<style lang="scss">
.v-card {
  &__text {
    .v-form {
      position: relative;
      .field-group {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-bottom: 80px;
        .v-input {
          margin: 0 25px;
          &__slot {
            border: none !important;
            padding: 0 !important;
            font-size: 36px;
            &:before {
              border-width: 2px 0 0 !important;
            }
            input {
              text-align: center;
              font-size: 36px;
              max-height: 50px;
              height: 100%;
            }
          }
        }
      }
      #errorText {
        position: absolute;
        bottom: 65px;
        left: 0;
        right: 0;
      }
    }
  }
  .v-btn {
    border-radius: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage/common/PinForm.vue